import React, { FC, useState } from "react";

interface Props {
  initialDate?: {
    startDate: string;
    endDate: string;
  };
  onApply: (range: { startDate: string; endDate: string }) => void;
  onCancel: () => void;
}

const DateRangeSelector: FC<Props> = ({ initialDate, onApply, onCancel }) => {
  const [startDate, setStartDate] = useState(initialDate?.startDate || "");
  const [endDate, setEndDate] = useState(initialDate?.endDate || "");

  return (
    <div className="bg-white p-6 rounded-xl shadow-xl w-full max-w-3xl">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Start Date
          </label>
          <input
            type="date"
            value={startDate}
            onChange={e => setStartDate(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            End Date
          </label>
          <input
            type="date"
            value={endDate}
            onChange={e => setEndDate(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2"
          />
        </div>
      </div>

      <div className="flex justify-end gap-3 mt-6">
        <button
          onClick={onCancel}
          className="bg-gray-200 text-gray-700 px-5 py-2 rounded hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          onClick={() => {
            if (!startDate || !endDate) {
              alert("Please select both dates.");
              return;
            }

            onApply({ startDate, endDate });
          }}
          className="bg-blue-600 text-white px-5 py-2 rounded hover:bg-blue-700"
        >
          Choose Date
        </button>
      </div>
    </div>
  );
};

export default DateRangeSelector;
